// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isUsersSubscriptionGroupsUsageIdResult = objectOf({
  campaigns: arrayOf(
    objectOf({
      name: string,
      id: string,
    })
  ),
  workflow_steps: arrayOf(
    objectOf({
      name: string,
      id: string,
    })
  ),
});
